
















import {Vue, Component} from 'vue-property-decorator';
@Component
export default class AuthorityPopupContentTop extends Vue {
  private dataInfo: any = '';
  private mounted(): void {
    this.$emit('initRequest', this.dataInfo);
  }
  private handleSearch(): void {
    this.$emit('initRequest', this.dataInfo);
  }
}
